import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
//import ComputerIcon from '@mui/icons-material/Computer';
import MemoryIcon from '@mui/icons-material/Memory';
import SpeedIcon from '@mui/icons-material/Speed';
import StorageIcon from '@mui/icons-material/Storage';
import SecurityIcon from '@mui/icons-material/Security';

const services = [
  'Hardware diagnostics and troubleshooting',
  'Operating system installation and updates',
  'Performance optimization',
  'Virus removal and security setup',
  'Data backup and recovery',
  'Hardware upgrades (RAM, Storage, GPU)',
  'Software installation and configuration',
  'Network setup and troubleshooting',
  'Regular maintenance and cleaning',
  'Custom desktop configurations'
];

const benefits = [
  {
    icon: SpeedIcon,
    title: 'Fast Service',
    description: 'Quick turnaround time for most desktop repairs and services'
  },
  {
    icon: SecurityIcon,
    title: 'Secure Handling',
    description: 'Your data and device security is our top priority'
  },
  {
    icon: MemoryIcon,
    title: 'Genuine Parts',
    description: 'We only use authentic components for replacements'
  },
  {
    icon: StorageIcon,
    title: 'Data Protection',
    description: 'Complete data backup and protection during service'
  }
];

const expertise = [
  {
    title: 'Hardware Issues',
    description: 'Fixing hardware malfunctions and component failures'
  },
  {
    title: 'Software Problems',
    description: 'Resolving software conflicts and system errors'
  },
  {
    title: 'Performance Issues',
    description: 'Optimizing system performance and speed'
  },
  {
    title: 'Upgrades',
    description: 'Hardware and software upgrades for better performance'
  }
];

function DesktopService() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      {/* Hero Section */}
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            className="gradient-text"
            sx={{ mb: 3 }}
          >
            Professional Desktop Services
          </Typography>
          <Typography
            variant="h5"
            sx={{ color: 'text.secondary', mb: 4 }}
          >
            Complete desktop maintenance and repair solutions
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2,
              px: 4,
              fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
              '&:hover': {
                background: 'linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)',
              }
            }}
          >
            Book Service Now
          </Button>
        </Box>

        {/* Benefits Section */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover">
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Services List */}
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            mb: 8,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Our Desktop Services
          </Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircleIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* Expertise Areas */}
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4,
            background: 'rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(10px)'
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Our Expertise
          </Typography>
          <Grid container spacing={3}>
            {expertise.map((area, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card 
                  className="glass-effect"
                  sx={{ 
                    textAlign: 'center',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: 2
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    {area.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {area.description}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default DesktopService;
